import { render, staticRenderFns } from "./OmniSearch.vue?vue&type=template&id=3996dc16&scoped=true&"
import script from "./OmniSearch.vue?vue&type=script&lang=js&"
export * from "./OmniSearch.vue?vue&type=script&lang=js&"
import style0 from "./OmniSearch.vue?vue&type=style&index=0&id=3996dc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996dc16",
  null
  
)

export default component.exports